import LayoutContainer from "../../components/Containers/LayoutContainer";
import PhotoChallengeData from "./PhotoChallengeData";

const Photos_Challenge = () => {
  return (
    <LayoutContainer title="Photo Challenge">
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          Photo Challenge Data
        </h2>
      </div>
      <PhotoChallengeData />
    </LayoutContainer>
  );
};

export default Photos_Challenge;
